import { render, staticRenderFns } from "./SupplementServiceRate.vue?vue&type=template&id=8c32f626&scoped=true"
import script from "./SupplementServiceRate.vue?vue&type=script&lang=js"
export * from "./SupplementServiceRate.vue?vue&type=script&lang=js"
import style0 from "./SupplementServiceRate.vue?vue&type=style&index=0&id=8c32f626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c32f626",
  null
  
)

export default component.exports